import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';
import ArticleCard from '@/components/base/ArticleCard';

export default function LatestNews() {
  const latestArticles = articles.filter((a) => a.isNew);

  return (
    <section className="py-10 md:py-14">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-8">
          <div>
            <div className="flex items-center gap-2 mb-1">
              <span className="w-2 h-2 rounded-full bg-secondary-500"></span>
              <span className="text-xs text-foreground-500 font-label uppercase tracking-wider">Latest</span>
            </div>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">
              最新爆料
            </h2>
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {latestArticles.map((article) => (
            <ArticleCard
              key={article.slug}
              slug={article.slug}
              title={article.title}
              excerpt={article.excerpt}
              categoryName={article.categoryName}
              categorySlug={article.category}
              imageUrl={article.imageUrl}
              publishDate={article.publishDate}
              readCount={article.readCount}
              isHot={article.isHot}
              isNew={article.isNew}
            />
          ))}
        </div>
      </div>
    </section>
  );
}